<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
import type { FormEmailInput } from '~/composables/useForm'

const props = defineProps<{
  data: FormEmailInput
}>()

const validation = computed(() => {
  return [
    'email',
    props.data.required ? 'required' : null,
  ].join('|')
})

const { dt } = useDirectusTranslation()
</script>

<template>
<FormKitLazyProvider config-file="true">

  <div>
    <FormKit
      :id="props.data.key"
      type="email"
      :name="props.data.key"
      :label="dt(props.data.translations)?.label"
      :placeholder="dt(props.data.translations)?.placeholder"
      :validation="validation"
    />
  </div>

</FormKitLazyProvider>
</template>

<style>

</style>
